
import {
    initializeApp
} from "firebase/app";
import {
    getFirestore
} from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCdFLnJQ2gKfR3NvAGvx4Q0pxcyR20JRKo",
    authDomain: "selhack-20336.firebaseapp.com",
    projectId: "selhack-20336",
    storageBucket: "selhack-20336.firebasestorage.app",
    messagingSenderId: "670025875928",
    appId: "1:670025875928:web:e1a8fd121fcdce0f21f2ad"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);